class ProductApplicationsTable {
    constructor($el) {
        this.$el = $el;
        this.$wrapper = null;
        this.$scrollbarWrapper = null;

        this.scrollbar = null;
        this.tableInstance = null;
        this.currentLeftOffset = 0;
        this.previousLeftOffset = 0;
        this.currentColumnIndex = 0;

        if(this.$el.length) {
            this._createTable();
            this._findDOMElements();
        }
    }

    _bindEvents() {
        this.toggleMenuFn = this.toggleMenu.bind(this);

        this.$el.on('click', this.toggleMenuFn);
    }

    _bindSyncedScroll() {
        this.$scrollbarWrapper.on('scroll', this._syncScroll.bind(this));
        this.$el.on('order.dt', this._onOrderChange.bind(this));
    }

    _bindPrevNextButtons() {
        this.$backwardButton.on('click', this._goToPreviousColumn.bind(this));
        this.$forwardButton.on('click', this._goToNextColumn.bind(this));
    }

    _createTable() {
        this.tableInstance = this.$el.DataTable({
            scrollY: 520,
            scrollX: true,
            scrollCollapse: true,
            paging: false,
            searching: false,
            ordering: true,
            info: false,
            autoWidth: false,
            columnDefs: [
                {targets: 'product-applications-table__cell-heading--manufacturer', width: '170px'},
                {targets: 'product-applications-table__cell-heading--model', width: '170px'},
                {targets: 'product-applications-table__cell-heading--fuel', width: '115px'},
                {targets: 'product-applications-table__cell-heading--engine', width: '115px'},
                {targets: 'product-applications-table__cell-heading--engineCode', width: '168px'},
                {targets: 'product-applications-table__cell-heading--powerKW', width: '168px'},
                {targets: 'product-applications-table__cell-heading--period', width: '118px'},
                {targets: 'product-applications-table__cell-heading--notfEnginecodApp', width: '236px'},
                {targets: 'product-applications-table__cell-heading--fromChassisApp', width: '195px'},
                {targets: 'product-applications-table__cell-heading--toChassisApp', width: '195px'},
                {targets: 'product-applications-table__cell-heading--fromEngineApp', width: '191px'},
                {targets: 'product-applications-table__cell-heading--toEngineApp', width: '191px'},
                {targets: 'product-applications-table__cell-heading--productionDateFrom', width: '231px'},
                {targets: 'product-applications-table__cell-heading--productionDateTo', width: '231px'},
                {targets: 'product-applications-table__cell-heading--position', width: '125px'},
                {targets: 'product-applications-table__cell-heading--transmission', width: '165px'},
                {targets: 'product-applications-table__cell-heading--emissions', width: '230px'},
                {targets: 'product-applications-table__cell-heading--catalysator', width: '210px'},
                {targets: 'product-applications-table__cell-heading--engineVersion', width: '210px'},
                {targets: 'product-applications-table__cell-heading--countriesIncluded', width: '230px'},
                {targets: 'product-applications-table__cell-heading--countriesExcluded', width: '230px'},
                {targets: 'product-applications-table__cell-heading--equipment', width: '210px'},
                {targets: 'product-applications-table__cell-heading--climateZonesApp', width: '210px'}
            ]
            // initComplete: this._onTableReady.bind(this)
        });

        this._onTableReady();
    }

    _onTableReady() {
        this._findDOMElements();
        this.columnsCount = this.$columnsTitles.length - 1;

        this._initTableScrollbar();
        this._bindSyncedScroll();
        this._bindPrevNextButtons();
    }

    _findDOMElements() {
        this.$wrapper = this.$el.parents('.product-informations-table-wrapper');
        this.$tableBody = this.$wrapper.find('.dataTables_scrollBody');
        this.$tableHead = this.$wrapper.find('.dataTables_scrollHead');
        this.$forwardButton = this.$wrapper.find('.manual-scroll-button--forward');
        this.$backwardButton = this.$wrapper.find('.manual-scroll-button--backward');
        this.$columnsTitles = this.$el.find('th');
    }

    _initTableScrollbar() {
        this.scrollbar = new SimpleBar(this.$tableBody[0]);
        this.$scrollbarWrapper = this.$tableBody.find('.simplebar-content-wrapper');
    }

    _syncScroll(e) {
        const $target = $(e.currentTarget);
        this.currentLeftOffset = $target.scrollLeft();

        // Update only on horizontal scroll
        // TODO: Update `this.currentColumnIndex` after horizontal scroll
        if(this.previousLeftOffset != this.currentLeftOffset) {
            this.previousLeftOffset = this.currentLeftOffset;

            if(this.$tableHead[0].scrollTo) {
                this.$tableHead[0].scrollTo(this.$scrollbarWrapper[0].scrollLeft, 0);
            }
            else {
                this.$tableHead[0].scrollLeft = this.$scrollbarWrapper[0].scrollLeft;
            }
        }
    }

    _onOrderChange() {
        // Force table heading update after table sort
        this.previousLeftOffset = 0;
        this._syncScroll({currentTarget: this.$scrollbarWrapper});
    }

    _goToPreviousColumn() {
        if(this.$backwardButton.hasClass('manual-scroll-button--disabled')) {
            return;
        }

        this.currentColumnIndex --;

        if(this.currentColumnIndex <= 0) {
            this.currentColumnIndex = 0;

            if(!this.$backwardButton.hasClass('manual-scroll-button--disabled')) {
                this.$backwardButton.addClass('manual-scroll-button--disabled');
            }
        }

        if(this.$forwardButton.hasClass('manual-scroll-button--disabled')) {
            this.$forwardButton.removeClass('manual-scroll-button--disabled');
        }

        if(this.$scrollbarWrapper[0].scrollTo) {
            this.$scrollbarWrapper[0].scrollTo(this.$columnsTitles.eq(this.currentColumnIndex).position().left, 0);
        }
        else {
            this.$scrollbarWrapper[0].scrollLeft = this.$columnsTitles.eq(this.currentColumnIndex).position().left;
        }
    }

    _goToNextColumn() {
        if(this.$forwardButton.hasClass('manual-scroll-button--disabled')) {
            return;
        }

        this.currentColumnIndex ++;

        if(this.currentColumnIndex > this.columnsCount) {
            this.currentColumnIndex = this.columnsCount;
            this.$forwardButton.addClass('manual-scroll-button--disabled');
        }

        if(this.$backwardButton.hasClass('manual-scroll-button--disabled')) {
            this.$backwardButton.removeClass('manual-scroll-button--disabled');
        }

        if(this.$scrollbarWrapper[0].scrollTo) {
            this.$scrollbarWrapper[0].scrollTo(this.$columnsTitles.eq(this.currentColumnIndex).position().left, 0);
        }
        else {
            this.$scrollbarWrapper[0].scrollLeft = this.$columnsTitles.eq(this.currentColumnIndex).position().left;
        }

        if(this.$scrollbarWrapper[0].scrollLeft + this.$scrollbarWrapper[0].offsetWidth >= this.$el[0].offsetWidth) {
            this.$forwardButton.addClass('manual-scroll-button--disabled');
        }
    }
}

export default ProductApplicationsTable;
